import { putMethodWithTokenWithLatLng } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const UPDATE_SALON_PROVIDER = 'UPDATE_SALON_PROVIDER';
export const UPDATE_SALON_PROVIDER_SUCCESS = 'UPDATE_SALON_PROVIDER_SUCCESS';
export const UPDATE_SALON_PROVIDER_FAILURE = 'UPDATE_SALON_PROVIDER_FAILURE';

// Action Creators
export const fetchUpdateSalonProvider = () => ({
  type: UPDATE_SALON_PROVIDER,
});

export const fetchUpdateSalonProviderSuccess = (data) => ({
  type: UPDATE_SALON_PROVIDER_SUCCESS,
  payload: data,
});

export const fetchUpdateSalonProviderFailure = (error) => ({
  type: UPDATE_SALON_PROVIDER_FAILURE,
  payload: error,
});

// Thunk Function
export const updateSalonProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchUpdateSalonProvider(data, external));
    try {
      const response = await putMethodWithTokenWithLatLng(
        url.updateSalonProviderSuperAdmin + data.url + '/',
        data?.payload,
        external?.latlng
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchUpdateSalonProviderSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchUpdateSalonProviderFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchUpdateSalonProviderFailure(error.message));
    }
  };
};
